import React, { useRef, useState, useEffect } from 'react';
import Plot from 'react-plotly.js';
import plot from "../../../components/CellInfo/plot.json";


const IReVsCyclePlot = ({ data, frameIndex, soh = 0.9, eolCycleCount = 4000 }) => {

    const currentCycle = Math.round(eolCycleCount - (soh * eolCycleCount));

    const sohIndex = data.x.reduce((prev, curr, index) =>
        Math.abs(curr - currentCycle) < Math.abs(data.x[prev] - currentCycle) ? index : prev, 0);

    const sohX = data.x[sohIndex];
    const sohY = data.y[sohIndex]; 

    const frames = Array.from({ length: data.x.length }, (_, k) => ({
        data: [
            {
                x: [data.x[k]],
                y: [data.y[k]],
            },
        ],
        traces: [1],
    }));


    return (
        <div>
            <Plot
                key="irVsCyclePlot"
                data={[{
                    x: data.x || [],
                    y: data.y || [],
                    mode: "lines",
                    line: { width: 2, color: "blue" },
                },
                {
                    x: [data.x ? data.x[frameIndex] : 0],
                    y: [data.y ? data.y[frameIndex] : 0],
                    mode: "markers",
                    marker: { color: "red", size: 10 },
                },
                {
                    x: [sohX],
                    y: [sohY],
                    mode: "markers+text",
                    text: [`SoH 90%`],
                    textposition: "top center",
                    marker: { color: "green", size: 12, symbol: 'star' },
                    name: 'SoH 90%',
                },
                ]}
                layout={{
                    ...plot.layout,
                    title: {
                        text: "Internal Resistance vs Cycle",
                        x: 0.5,
                    },
                    xaxis: {
                        title: "Cycle",
                        range: [data.xm, data.xM],
                        autorange: false,
                        zeroline: false,
                    },
                    yaxis: {
                        title: "Internal Resistance (Ohm)",
                        range: [data.ym, data.yM],
                        autorange: false,
                        zeroline: false,
                    },
                    annotations: [],
                    showlegend: false,
                    legend: {
                        orientation: "h",
                        title: "",
                    },
                    height: 310,
                    width: 650,
                }}
                frames={frames}
                config={{ responsive: true }}
            />
        </div>
    );
};

export default IReVsCyclePlot;
